import { Input } from '../../../components/ui/input';

type ConversationFiltersProps = {
  readonly search: string;
  readonly dateFrom: string;
  readonly dateTo: string;
  readonly onSearchChange: (value: string) => void;
  readonly onDateFromChange: (value: string) => void;
  readonly onDateToChange: (value: string) => void;
};

export function ConversationFilters({
  search,
  dateFrom,
  dateTo,
  onSearchChange,
  onDateFromChange,
  onDateToChange,
}: ConversationFiltersProps) {
  return (
    <>
      <Input
        placeholder="Søk i navn eller nummer..."
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
      />
      <div className="grid grid-cols-2 gap-2">
        <Input
          label="Fra dato"
          type="date"
          value={dateFrom}
          onChange={(event) => onDateFromChange(event.target.value)}
        />
        <Input
          label="Til dato"
          type="date"
          value={dateTo}
          onChange={(event) => onDateToChange(event.target.value)}
        />
      </div>
      <p className="text-[11px] text-[#5e6070]">
        Datofilter avgrenser hvilke meldinger som importeres fra de valgte samtalene.
      </p>
    </>
  );
}
